import Text from 'components/shared/Text'
import { FormattedMessage } from 'react-intl'
import {
    ColumnWrapper,
    CustomBox,
    OpeningHoursWrapper,
    ZonesWrapper,
} from './styles'
import Box from 'components/shared/Box'
import { useResolutions } from 'store/resolutions'
import { OpeningHoursDto } from 'store/api-slice/hooks'

export interface DifferentHoursProps {
    isClosed?: boolean
    season: OpeningHoursDto
}

interface HoursColumns {
    columnDay: string
    columnHours: string[]
}

const DifferentHours = ({
    isClosed = false,
    season: { attractions, rows },
}: DifferentHoursProps) => {
    const { isSmallTablet } = useResolutions()

    const zonesColumn = () => (
        <>
            <ZonesWrapper gap={[20, 24]}>
                {!isSmallTablet && (
                    <Box direction="row">
                        <Text variant="bodyLargeStrong" color="primary_500">
                            <FormattedMessage
                                id="global.modal.opening_hours_zones_attractions_caption"
                                defaultMessage="Strefy i atrakcje"
                            />
                        </Text>
                    </Box>
                )}

                {attractions?.map((attraction) => (
                    <Box direction="row" key={attraction.attractionKey}>
                        <Text
                            variant={isSmallTablet ? 'bodySmall' : 'body'}
                            color="grayscale_900"
                        >
                            {attraction.title}
                        </Text>
                    </Box>
                ))}
            </ZonesWrapper>
        </>
    )

    const hoursRows = () => {
        if (!attractions || !rows) return null

        let sliceStart = 0
        let sliceEnd = 4

        const hoursRows: string[][] = [rows.slice(sliceStart, sliceEnd)]

        // Create new array with equal elements
        // if there is more than 4 hours columns in season
        rows.forEach((_, index) => {
            if (index >= 4 && index % 4 === 0) {
                sliceStart = sliceStart + 4
                sliceEnd = sliceEnd + 4

                hoursRows.push(rows.slice(sliceStart, sliceEnd))
            }
        })

        /** Because api returns data for old opening hours theme (rows as days of the week),
         * now rows are zones and attractions so needs to create new array with column
         * day an hours list */

        let rowIndex = 0

        const hoursColumns = (rows: string[]) => {
            const columns: HoursColumns[] = []

            rows?.forEach((row) => {
                const columnHours: string[] = []

                attractions.forEach((attraction) => {
                    const { hours } = attraction

                    if (!hours) return

                    const hoursArray = Object.keys(hours)

                    hoursArray.forEach((_, index) => {
                        if (index === rowIndex) {
                            columnHours.push(hours[index])
                        }
                    })
                })

                rowIndex++

                columns.push({
                    columnDay: row,
                    columnHours,
                })
            })

            return columns
        }

        return hoursRows.map((hourRow, index) => (
            <CustomBox gap={32} mb={isClosed ? 0 : [8, 0]} key={index}>
                {!isSmallTablet && zonesColumn()}

                {hoursColumns(hourRow).map((column, index) => {
                    const { columnHours, columnDay } = column

                    return (
                        <Box
                            key={index}
                            direction={['row', 'column']}
                            isFullWidth={true}
                            justify="space-between"
                            alignSelf={['flex-start', 'flex-end']}
                        >
                            {isSmallTablet && (
                                <Box>
                                    <Text
                                        variant={
                                            isSmallTablet
                                                ? 'body'
                                                : 'bodyLargeStrong'
                                        }
                                        color="primary_500"
                                        mb={24}
                                    >
                                        {columnDay}
                                    </Text>
                                    {zonesColumn()}
                                </Box>
                            )}
                            <ColumnWrapper direction="column" gap={[20, 24]}>
                                {!isSmallTablet && (
                                    <Box>
                                        <Text
                                            variant={
                                                isSmallTablet
                                                    ? 'body'
                                                    : 'bodyLargeStrong'
                                            }
                                            color="primary_500"
                                        >
                                            {columnDay}
                                        </Text>
                                    </Box>
                                )}

                                {columnHours.map((hour, index) => (
                                    <Box
                                        direction="row"
                                        key={`${index}`}
                                        className="column"
                                    >
                                        <Text
                                            variant={
                                                isSmallTablet
                                                    ? 'bodySmall'
                                                    : 'body'
                                            }
                                            color="grayscale_900"
                                        >
                                            {hour}
                                        </Text>
                                    </Box>
                                ))}
                            </ColumnWrapper>
                        </Box>
                    )
                })}
            </CustomBox>
        ))
    }
    return (
        <OpeningHoursWrapper
            direction="column"
            justify={['flex-start', 'space-between']}
            gap={[32, 50]}
            isFullWidth={true}
            isClosed={isClosed}
        >
            {hoursRows()}
        </OpeningHoursWrapper>
    )
}

export default DifferentHours
